import Navigation from './Navigation';
import { useMediaQuery } from 'usehooks-ts';

const NavigationContainer = () => {
  const matches = useMediaQuery('(min-width: 1440px)');
  return <Navigation isNarrow={!matches} />;
};

export default NavigationContainer;
